/**
 * VÉRAULT — responsive image helpers for the Pexels-backed itinerary
 * image library. We keep one clean master URL and derive optimized,
 * width-specific renditions on the Pexels CDN (auto WebP + compression),
 * so mobile never downloads a full 4K master.
 */
const DEFAULT_WIDTHS = [480, 768, 1024, 1440, 1920];

function isPexels(url) {
  return typeof url === "string" && url.includes("images.pexels.com");
}

/** A single width-bounded rendition (auto WebP + crop). */
export function pexelsAt(url, width, { height, fit = "crop" } = {}) {
  if (!url) return url;
  const base = url.split("?")[0];
  if (!isPexels(base)) return base;
  const parts = [`auto=compress`, `cs=tinysrgb`, `fit=${fit}`, `w=${width}`];
  if (height) parts.push(`h=${height}`);
  return `${base}?${parts.join("&")}`;
}

/** srcset string across standard widths. */
export function pexelsSrcSet(url, widths = DEFAULT_WIDTHS) {
  const base = url ? url.split("?")[0] : "";
  if (!isPexels(base)) return undefined;
  return widths.map((w) => `${pexelsAt(base, w)} ${w}w`).join(", ");
}

/** object-position string from a stored focal point (0..1). */
export function focalPosition(image) {
  const x = Math.round(((image?.focal_x ?? 0.5)) * 100);
  const y = Math.round(((image?.focal_y ?? 0.5)) * 100);
  return `${x}% ${y}%`;
}

/** Resolve a usable src from either an image object or a legacy string URL. */
export function imageUrlOf(imageOrUrl) {
  if (!imageOrUrl) return null;
  if (typeof imageOrUrl === "string") return imageOrUrl;
  return imageOrUrl.url || imageOrUrl.large_url || imageOrUrl.original_url || null;
}
